import axios, { AxiosResponse } from 'axios';

export const httpInstance = axios.create({
  baseURL: import.meta.env.VITE_LEYANBOT_HOST,
  headers: {
    [import.meta.env.VITE_AUTH_HEADER]: `Bearer ${localStorage.getItem('token')}`,
  },
});

httpInstance.interceptors.request.use((config) => {
  config.headers[import.meta.env.VITE_AUTH_HEADER] = `Bearer ${localStorage.getItem('token')}`;
  return config;
});

export interface ResponseType<T = unknown> {
  data: T;
}

export const resolveData = <T>(promise: Promise<AxiosResponse<ResponseType<T>>>) => {
  return promise.then((res) => res.data.data);
};
